import React, { useEffect, useState, useCallback } from 'react';
import Constantes from '../../constantes';
import { useSearchParams } from 'react-router-dom';
function RegistroCompleto() {
    const [email, setEmail] = useState('');
    const [searchParams] = useSearchParams();

    const validarEmail = useCallback(async (mail) => {
        if (mail) {
            await fetch(Constantes.RUTA_API + '/usuarios/verificarUsuario', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({email: mail}),
            })
        }
    }, []);

    useEffect(() => {
        const email_url = searchParams.get('email');
        if (email_url) {
            setEmail(email_url);
            validarEmail(email_url)
        }
        

    }, [searchParams, validarEmail]);

    return (
        <>
            <div className="App d-flex justify-content-center bg-dark text-white">
                <div class="mb-4 mt-4 text-center">
                    {email && <>
                        <h1>Tu cuenta "{email}" ha sido vinculada a satisfactoriamente</h1>

                        <br />

                        <h3>Disfruta de la aplicación y para cualquier duda no dudes en contactarnos en <a href='mailto:yourny.oficial+consultas@gmail.com'>yourny.oficial@gmail.com</a></h3>

                        <br />

                        <br />

                        <button type="button" class="my-4 btn btn-primary" onClick={() => { window.location.href = "/login" }}>Ir a inicio de sesión</button>
                    </>
                    }
                    {!email &&
                        <>
                            <h1>Alma de 🥒 sin 🆔 ¿Cómo has conseguido esta URL sin registrarte?</h1>
                            <br />
                            <h3>Cuentanoslo en <a href='mailto:yourny.oficial+bug_registro@gmail.com'>yourny.oficial@gmail.com</a></h3>
                        </>
                    }

                </div>
            </div >


            <title>Registro completado</title>

        </>

    );
}

export default RegistroCompleto;